<script setup lang="ts">
import { onMounted } from 'vue';
import { NavigationFailure } from 'vue-router';
import { useRoute, router } from '@hfc/ui-core';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { UUID } from '@hfc/common/src/types/UUID';
import FeedbackForm from '@/shared/infrastructure/components/FeedbackForm.vue';
import { useAppStore } from '@/shared/infrastructure/composition/useAppStore';

const { appState } = useAppStore();
const route = useRoute();

const applicationType = route.params.applicationType as string;
const uuid = route.params.uuid as UUID;

const getApplicationType = (applicationType: string): APPLICATION_TYPES | undefined => {
  return Object.values(APPLICATION_TYPES).find(type => type === applicationType);
};

const feedbackSubmitSuccess = (): Promise<NavigationFailure | void | undefined> => {
  return router.push({ name: 'FeedbackThankYou' });
};

onMounted(() => {
  const token = appState.value.feedbackUserData?.token;
  if (uuid && !token) {
    router.push({ name: 'FeedbackChallengeQuestions', params: { applicationType, uuid } });
  }
});
</script>
<template>
  <FeedbackForm :application-type="getApplicationType(applicationType)" :uuid="uuid" @feedback-success="feedbackSubmitSuccess" />
</template>
